<template>
  <yd-slider  class="borderTop" autoplay="5000" style="height: 4.17rem">
    <!--<yd-slider-item>-->
    <!--<router-link :to="{path:'/bannerDetail', query:{id: 3}}">-->
    <!--<img src="../../../static/ronganwx/img/new-banner.jpg" />-->
    <!--</router-link>-->
    <!--</yd-slider-item>-->

    <!--<yd-slider-item>-->
      <!--<img src="../../../static/ronganwx/img/new-banner.jpg" />-->
    <!--</yd-slider-item>-->

    <yd-slider-item>
    <a href="http://wxc76ce18c45894494.dodoca.com/authorize/redirect?param=bDhCY1c0bkNtNWlEU1RLZkx3eWVmdmNXcWk5ak9aNjlXcVNXcHFOZG9nUmF0c0s2SXplWTh0ZjVqdk5iZ3orMmlrR09VWCs4N1JPTlNPMXQ=&uid=a3NaWEN0YkR4cDdLWDM3ZWUwWQ==">
    <img src="../../../static/ronganwx/img/banner_201903282.jpg" />
    </a>
    </yd-slider-item>
    <!--<yd-slider-item  >-->
    <!--<router-link :to="{path:'/bannerDetail', query:{id: 2}}">-->
    <!--<img src="../../../static/ronganwx/img/new-banner1.jpg" />-->
    <!--</router-link>-->
    <!--</yd-slider-item>-->
  </yd-slider>
</template>

<script>
  export default {
    name: 'IndexApply',
    props: {
      src: {
        type: String,
        default: 'http://static.ydcss.com/uploads/ydui/1.jpg',
      },
      bgcolor: {
        type: String,
        default: '19b4e7',
      },
    },
    data() {
      return {};
    },
    created() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/base';

  .addressFz{
    color: $fontWhite;
    margin-left: 0.1rem;
  }
  .borderBottom{
    border-bottom: 6px solid $borderBottomColor;
  }
  .index-tell{
    height: 1rem;
  }
</style>



// WEBPACK FOOTER //
// index.vue?125655b5